import axios from 'axios';
import { useEffect, useRef, useState } from 'react';

import { useStores } from '../stores';
import { getStringLength } from '../utilities';
import useConfig from './useConfig';

export default function useSuggestions({ SearchText, SuggQuesCount, ProjectId, isDisabled }) {
  const {
    messageInput: { autoSuggestMinLength, maxLength }
  } = useConfig();
  const [suggestions, setSuggestions] = useState([]);
  const cancelToken = useRef(null);
  const { bot } = useStores();

  useEffect(() => {
    if (isDisabled) {
      return () => {};
    }

    const inputLength = getStringLength(SearchText, true);

    if (inputLength >= autoSuggestMinLength && inputLength <= maxLength) {
      cancelToken.current = axios.CancelToken.source();

      bot
        .getSuggestions(
          {
            ProjectId,
            SuggQuesCount,
            SearchText: SearchText.trim()
          },
          cancelToken.current.token
        )
        .then(setSuggestions);
    } else {
      setSuggestions([]);
    }

    return () => {
      if (cancelToken.current) {
        cancelToken.current.cancel();
      }
    };
  }, [ProjectId, SearchText, SuggQuesCount, autoSuggestMinLength, bot, isDisabled, maxLength]);

  return { suggestions, setSuggestions };
}
